import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import swal from "sweetalert";
import { printInfoMessage, routeConstants } from "../../../../shared/constants";
import { firmSizeRangeAtom, selectedFiltersAtom, selectedSpatialValueAtom, spatialParameterAtom, yearsRangeAtom } from "../../../../shared/state/atoms";
import FirmSizeRangeSlider from "../../../../shared/components/FirmSizeRangeSlider";

// Filter for Small Business / Establishments vs Employment (Phase C8).
function EstablishmentsVsEmploymentFilter() {
  const navigate = useNavigate();
  const [yearsRange] = useAtom(yearsRangeAtom);
  const [selectedFilters, setSelectedFilters] = useAtom(selectedFiltersAtom);
  const [spatialParameter] = useAtom(spatialParameterAtom);
  const [selectedSpatialValue] = useAtom(selectedSpatialValueAtom);
  const [firmSizeRange] = useAtom(firmSizeRangeAtom);

  const handles = firmSizeRange?.establishmentsVsEmployment?.handles ?? [10, 50, 250, 1000];

  useEffect(() => {
    if (!selectedFilters.singleYear || selectedFilters.singleYear < yearsRange[0]) {
      setSelectedFilters({
        ...selectedFilters,
        singleYear: yearsRange[yearsRange.length - 1],
      });
    }
  }, [selectedFilters, setSelectedFilters, yearsRange]);

  const handlePrintNavigation = async () => {
    await swal("Please Note", printInfoMessage, "info");
    window.open(`${routeConstants.PDF_PREVIEW}/establishmentsVsEmploymentPdf`, "_blank");
  };

  const handlePrintAllNavigation = async () => {
    await swal("Please Note", printInfoMessage, "info");
    navigate(`${routeConstants.PDF_PREVIEW}/all`);
  };

  const handleExportData = async (exportType) => {
    window.open(
      `${process.env.REACT_APP_API_URL}/api-export/dashboard-establishments-vs-employment/?${spatialParameter}=${selectedSpatialValue}` +
      `&year=${selectedFilters?.singleYear}` +
      `&handle1=${handles[0]}&handle2=${handles[1]}&handle3=${handles[2]}&handle4=${handles[3]}` +
      `&export=${exportType}`
    );
  };

  return (
    <div className="w-full">
      <div>
        <div style={{ fontSize: "16px" }} className="font-bold pb-5">
          Toggles:
        </div>
        <div style={{ borderBottom: "1px solid lightgrey" }} className="flex justify-between mb-4 pb-4">
          <label>Year:</label>
          <select
            className="border"
            name="singleYear"
            value={selectedFilters?.singleYear ?? ""}
            onChange={(e) =>
              setSelectedFilters({
                ...selectedFilters,
                singleYear: e.target.value,
              })
            }
          >
            {yearsRange.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </div>
        <div style={{ borderBottom: "1px solid lightgrey" }} className="mb-4 pb-4">
          <label>Firm Size Range (FTE Employees):</label>
          <FirmSizeRangeSlider
            dashboardId="establishmentsVsEmployment"
            numHandles={4}
            segmentLabels={["Micro", "Small", "Medium", "Large", "V Large"]}
            segmentColors={["#009640", "#66bb6a", "#84746C", "#F5C242", "#F0A400"]}
          />
        </div>
      </div>
      <div style={{ marginTop: "30px", borderBottom: "1px solid lightgrey", flexDirection: "column" }} className="flex justify-between mb-4 pb-8">
        <div style={{ fontSize: "16px" }} className="font-bold pb-5">
          Actions:
        </div>
        <div style={{ flexDirection: "row" }}>
          <button
            style={{
              border: "2px solid #F0A400",
              borderRadius: "50px",
              padding: "8px",
              paddingLeft: "14px",
              color: "#F0A400",
              width: "100%",
              marginBottom: "10px",
            }}
            className="font-sans"
            onClick={handlePrintNavigation}
          >
            Print Current Dashboard
          </button>
          <button
            style={{
              border: "2px solid #F0A400",
              borderRadius: "50px",
              padding: "8px",
              paddingLeft: "14px",
              color: "#F0A400",
              width: "100%",
            }}
            className="font-sans"
            onClick={handlePrintAllNavigation}
          >
            Print All Dashboards
          </button>
        </div>
      </div>
      <div style={{ marginTop: "30px", borderBottom: "1px solid lightgrey", flexDirection: "column" }} className="flex justify-between mb-4 pb-8">
        <div style={{ fontSize: "16px" }} className="font-bold pb-5">
          Download Data:
        </div>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
          <button
            style={{
              border: "2px solid #F0A400",
              borderRadius: "50px",
              padding: "8px",
              paddingLeft: "14px",
              marginRight: "5px",
              color: "#F0A400",
              width: "100%",
            }}
            className="font-sans"
            title="Export a CSV or XLSX which is the dataset used to generate the dashboard currently being viewed"
            onClick={() => handleExportData("csv")}
          >
            CSV
          </button>
          <button
            style={{
              border: "2px solid #F0A400",
              borderRadius: "50px",
              padding: "8px",
              paddingLeft: "14px",
              marginLeft: "5px",
              color: "#F0A400",
              width: "100%",
            }}
            className="font-sans"
            title="Export a CSV or XLSX which is the dataset used to generate the dashboard currently being viewed"
            onClick={() => handleExportData("xlsx")}
          >
            XLSX
          </button>
        </div>
      </div>
    </div>
  );
}

export default EstablishmentsVsEmploymentFilter;
